module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAAGpNG6TAAAAAXNSR0IArs4c6QAAAEpJREFUCB1jYACDhP0cEAZD0NYZUBYGlXaGiwks+PZlCyND6DYthr//r0JUhe/WRFUOFGBkAJn69bsSUFkeUDYdVUXw1j5UAaDxAKqZFbXqckx0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/icons/Combined Shape.png
// module id = 647
// module chunks = 0